import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=7f12faec&scoped=true&"
import script from "./ViewForm.vue?vue&type=script&lang=js&"
export * from "./ViewForm.vue?vue&type=script&lang=js&"
import style0 from "./ViewForm.vue?vue&type=style&index=0&id=7f12faec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f12faec",
  null
  
)

export default component.exports